module.exports = __webpack_public_path__ + "static/media/runway_amex.ed764927.jpg";